import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    carrierId?: string;
    carrierName?: string;
    shipViaId?: string;
}>;

export const DispatchSetSelectedCarrier: HandlerType = props => {
    props.dispatch({
        type: "Shipping/SetSelectedCarrier",
        carrierId: props.parameter.carrierId,
        carrierName: props.parameter.carrierName,
        shipViaId: props.parameter.shipViaId,
    });
};

export const chain = [DispatchSetSelectedCarrier];

const setSelectedCarrier = createHandlerChainRunner(chain, "SetSelectedCarrier");
export default setSelectedCarrier;
